import { IModel } from '../index';

export class EnderecoModel implements IModel {

    public bairro: string;

    public cidade: string;

    public logradouro: string;

    public complemento: string;

    public estado: string;

    public cep: number;

    public codigoMunicipioIBGE: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/endereco/endereco.model.ts